module.exports = __webpack_public_path__ + "static/media/full_6.0c4af525.jpg";